import { render, staticRenderFns } from "./noticeBar.vue?vue&type=template&id=05ce0cc9&scoped=true"
import script from "./noticeBar.vue?vue&type=script&lang=js"
export * from "./noticeBar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05ce0cc9",
  null
  
)

export default component.exports